import jwt from '@/http/requests/auth/jwt'

export default {

  fetchCampaigns ({ commit }, idOrganisation) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/campaign/list', { idOrganisation })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCampaignsByAdvertiser ({ commit }, idAdvertiser) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/campaign/list', { idAdvertiser: idAdvertiser })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCampaign (context, idCampaign) {
    return new Promise((resolve, reject) => {
      const url = idCampaign ? `/api/admin/campaign/${idCampaign}` : "/api/admin/campaign/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVoucher (context, payload) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/voucher/bycode`
      jwt.get(url, payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCampaignCategories (context, idCampaign) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/campaign/${idCampaign}/categories`
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveCampaign (context, updatedData) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/campaign/${updatedData.id}`)
        .then((response) => {
          const data = response.data.campaign
          Object.assign(data, updatedData)
          jwt.post('/api/admin/campaign/save', data)
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { reject(error) })
        }).catch((error) => { reject(error) })

    })
  },
  removeRecord ({ commit }, idCampaign) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/campaign/delete/${idCampaign}`)
        .then((response) => {
          commit('REMOVE_RECORD', idCampaign)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchImages (context, idCampaign) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/campaign/${idCampaign}/images`
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  reorderImages (context, data) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/campaign/${data.idCampaign}/images/reorder`
      jwt.post(url, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addImage (context, data) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/campaign/${data.idCampaign}/image`
      jwt.post(url, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteImage (context, id) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/campaign/image/delete/${id}`
      jwt.post(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUnmappedCampaigns ({ commit }, idAdvertiser) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/advertiser/${idAdvertiser}/campaigns/unmapped`)
        .then((response) => {
          commit('SET_UNMAPPED_CAMPAIGNS', response.data.items)
          resolve(response.data.items)
        })
        .catch((error) => { reject(error) })
    })
  },
  addCampaignsToAdvertiser (context, payload) {
    return jwt.post(`/api/admin/advertiser/${payload.id}/campaigns/add`, payload)
  },
  fetchCampaignBanners (context, idCampaign) {
    return new Promise((resolve, reject) => {
      const url = `/api/campaign/${idCampaign}/banners`
      jwt.get(url)
        .then((response) => {
          resolve(response.data.items)
        })
        .catch((error) => { reject(error) })
    })
  },
}
